import "./SuperAdminAllRefundRequest.css";

import React from "react";

import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import RefundStatusActions from "../../Common/RefundStatusActions";
import StripeOnboardingRequiredPopup from "Components/Popup/StripeOnboardingRequiredPopup/StripeOnboardingRequiredPopup";
import useRefundRequests from "../../Common/useRefundRequests";

const COLUMNS = [
  { label: "DATE", render: (curr) => curr?.dateTime },
  { label: "TRANSACTION ID", render: (curr) => curr?.transactionId },
  { label: "REQUESTOR ORG", render: (curr) => curr?.requestorOrg },
  { label: "REQUESTEE ORG", render: (curr) => curr?.requesteeOrg },
  { label: "REASON", render: (curr) => curr?.reason },
  {
    label: "CREDITS",
    contentStyle: { color: "#5CA127", fontWeight: "bold" },
    render: (curr) => curr?.credit,
  },
];

const SuperAdminAllRefundRequest = () => {
  const {
    loader,
    requestList,
    handleSearchInput,
    filterData,
    changeStatus,
    showStripeOnboardingPopup,
    setShowStripeOnboardingPopup,
    stripeDashboardUrl,
  } = useRefundRequests();

  return (
    <>
      <div className="super-admin-all-refund-request-parent">
        <div className="super-admin-all-refund-request-header">
          <Headers />
        </div>

        <div className="super-admin-all-refund-request-navigation">
          <Navigation />
        </div>

        <div className="super-admin-all-refund-request-main">
          <div className="super-admin-all-refund-request-wrapper">
            <div className="super-admin-all-refund-request-heading">
              Refund Request Page
            </div>
            <div className="super-admin-all-refund-request-all-active">
              <div className="super-admin-all-refund-request-top">
                <input
                  type="search"
                  placeholder="Search"
                  onChange={(e) => handleSearchInput(e.target.value)}
                />
                <div>
                  <p>Filter:</p>
                  <select onClick={(e) => filterData(e.target.value)}>
                    <option value="all">All</option>
                    <option value="pending">PENDING</option>
                    <option value="approved">APPROVED</option>
                    <option value="rejected">REJECTED</option>
                  </select>
                </div>
              </div>
              <div className="super-admin-all-refund-request-row-wrapper">
                {[...COLUMNS, { label: "ACTIONS" }].map(({ label }) => (
                  <div
                    key={label}
                    className="super-admin-all-refund-request-head-row"
                  >
                    {label}
                  </div>
                ))}
              </div>
              <div className="super-admin-all-refund-request-bottom">
                {requestList?.length?.toString() !== "0" ? (
                  requestList?.map((curr, index) => (
                    <div
                      className="super-admin-all-refund-request-content-wrapper"
                      key={index}
                    >
                      {COLUMNS.map(({ label, contentStyle, render }) => (
                        <div
                          key={label}
                          className="super-admin-all-refund-request-content-row"
                          style={contentStyle}
                        >
                          {render(curr)}
                        </div>
                      ))}
                      <div className="super-admin-all-refund-request-content-row">
                        <RefundStatusActions
                          request={curr}
                          changeStatus={changeStatus}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="super-admin-all-refund-request-msg">
                    No Requests Found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showStripeOnboardingPopup && (
        <StripeOnboardingRequiredPopup
          hide={setShowStripeOnboardingPopup}
          dashboardUrl={stripeDashboardUrl}
        />
      )}
      {loader}
    </>
  );
};

export default SuperAdminAllRefundRequest;
